import React, { useContext } from "react";
import PageLink from 'components/PageLink/PageLink';

interface Props {
    buttonUrl?: string;
    buttonText?: string;
    classNames?: string;
}

const CallBackButton = ({ buttonUrl, buttonText, classNames }: Props) => {
    return (
        <PageLink
        url={buttonUrl || ""}
        text={buttonText}
        className={classNames}
      />
    );
};

export default CallBackButton;
